/* eslint-disable @typescript-eslint/ban-ts-ignore */
/* eslint-disable @typescript-eslint/camelcase */
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import ComponentLibrary from '../../src/components';
import * as config from './config';

const vuetifyConfig = {
  components: {},
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      // Default/core styling
      light: config.theme
    }
  }
};

Vue.use(ComponentLibrary);
Vue.use(Vuetify, vuetifyConfig);

const VuetifyPlugin = new Vuetify(vuetifyConfig);

Vue.mixin({
  beforeCreate: function beforeCreate() {
    // @ts-ignore
    if (this.$options.DesignSystem) {
      // @ts-ignore
      this.$options.DesignSystem.init(this, this.$ssrContext);
    }
    // @ts-ignore
    this.$vuetify = VuetifyPlugin.framework;
  },
  beforeMount: function beforeMount() {
    // @ts-ignore
    if (this.$el && this.$el.hasAttribute('data-server-rendered')) {
      // @ts-ignore
      this.$vuetify.isHydrating = true;
      // @ts-ignore
      this.$vuetify.breakpoint.update(true);
    }
  },
  mounted: function mounted() {
    // @ts-ignore
    if (this.$vuetify.isHydrating) {
      // @ts-ignore
      this.$vuetify.isHydrating = false;
      // @ts-ignore
      this.$vuetify.breakpoint.update();
    }
  }
});

export default VuetifyPlugin;
